import type { BusVehicleTypeFieldErrors, BusVehicleTypeMutation } from "../types";

export { createBusVehicleType, fetchBusVehicleTypeCandidates, fetchBusVehicleTypes, updateBusVehicleType } from "../repo/busVehicleTypeRepo";

/** 提交前规范化名称。 */
export function normalizeBusVehicleType(payload: BusVehicleTypeMutation): BusVehicleTypeMutation {
  return { ...payload, name: payload.name.normalize("NFKC").trim().replace(/\s+/gu, " ") };
}

/** 给出车型表单字段错误，拒绝非法整数。 */
export function validateBusVehicleType(payload: BusVehicleTypeMutation): BusVehicleTypeFieldErrors {
  const normalized = normalizeBusVehicleType(payload);
  const errors: BusVehicleTypeFieldErrors = {};
  if (!normalized.name || [...normalized.name].length > 100) errors.name = "请填写 1–100 字的车型名称。";
  if (!Number.isInteger(payload.seatCount) || payload.seatCount < 1 || payload.seatCount > 200) {
    errors.seatCount = "座位数须为 1–200 的整数。";
  }
  if (!Number.isInteger(payload.sortNo) || payload.sortNo < 0 || payload.sortNo > 2147483647) {
    errors.sortNo = "排序须为 0–2147483647 的整数。";
  }
  return errors;
}
